module.exports = __webpack_public_path__ + "img/icon5.dd2d59fa.png";